import { Component, Input, OnInit } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-rabobank',
  templateUrl: './userapi-rabobank.component.html'
})
export class UserapiRabobankComponent extends AbstractUserApiModalComponent implements OnInit {
  @Input() userApi: UserAPI;

  public permissionGranted = false;

  ngOnInit(): void {
    this.permissionGranted = !!this.userApi.id;
    if (!!this.userApi.privateKey) {
      this.userApi.configured = true;
    }
  }

  valueChanged() {
    this.userApi.configured = !!this.userApi.publicKey && this.permissionGranted;
  }

  togglePermissionGranted() {
    this.permissionGranted = !this.permissionGranted;
    this.valueChanged();
  }
}
